import { LoaderCircle } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../../lib/api";

const extractSessionId = () => {
  const match = window.location.hash.match(/session_id=([^&]+)/);
  return match ? decodeURIComponent(match[1]) : null;
};

export default function AuthCallbackPage() {
  const sessionId = extractSessionId();
  const { error } = useQuery({
    queryKey: ["google-auth-callback", sessionId],
    queryFn: async () => { await apiFetch("/auth/google-session", { method: "POST", body: JSON.stringify({ session_id: sessionId }) }); window.location.replace(`${window.location.origin}/#/admin`); return true; },
    enabled: Boolean(sessionId),
    retry: false,
    staleTime: Infinity,
  });
  const errorMessage = sessionId ? error?.message : "Missing Google session. Please return to the login page.";

  return <main className="auth-callback" data-testid="auth-callback-page">
    <img src="/ncp-mechanical-logo.png" alt="NCP Mechanical Ltd" />
    {errorMessage ? <p className="admin-error" data-testid="auth-callback-error">{errorMessage}</p> : <><LoaderCircle className="spin" /><p data-testid="auth-callback-status">Securing your admin session…</p></>}
  </main>;
}